import type { MathRun } from '../../../Shared/Pdf/mathRuns.ts';

/** English number-property prompts (ADR 0051 part 3). Unchanged from the original inline text. */
export const numberPropertyPrompts = {
    multiples: (count: number, base: number) => `List the first ${count} multiples of ${base}.`,
    gcf: (a: number, b: number) => `What is the greatest common factor of ${a} and ${b}?`,
    lcm: (a: number, b: number) => `What is the least common multiple of ${a} and ${b}?`,
    primeComposite: (value: number) => `Is ${value} prime or composite?`,
    evenOdd: (value: number) => `Is ${value} even or odd?`,
    // ADR 0132. The radical is a run, drawn by MathText; the French question mark
    // keeps its no-break space (U+00A0, which WinAnsi has).
    estimatingRoots: (radicand: number): MathRun[] => [
        { text: 'Between which two whole numbers is ' },
        { root: String(radicand) },
        { text: '?' },
    ],
    factors: (value: number) => `List all the factors of ${value}.`,
};

export const primeCompositeLabels = { prime: 'Prime', composite: 'Composite' };
export const evenOddLabels = { even: 'Even', odd: 'Odd' };

/** The key to an estimating question: the two whole numbers a root falls between. */
export const rootPairKey = (lower: number, upper: number) => `${lower} and ${upper}`;
